(function () {
    const host = document.querySelector('[data-first-atc-confetti]');
    if (!host || host.dataset.bound === '1') return;
    host.dataset.bound = '1';

    const storageKey = host.dataset.storageKey || 'sherbet_first_atc';
    const particles = parseInt(host.dataset.particles || '48', 10);
    const duration = parseInt(host.dataset.duration || '1600', 10);
    const colors = (host.dataset.colors || '#ff6b9d,#ffd166,#06d6a0,#118ab2,#f78c6b').split(',').map((s) => s.trim()).filter(Boolean);

    const alreadyFired = () => {
      try { return !!localStorage.getItem(storageKey); } catch (e) { return false; }
    };
    const markFired = () => {
      try { localStorage.setItem(storageKey, '1'); } catch (e) {}
    };

    const burst = () => {
      host.innerHTML = '';
      const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced) return;
      if (typeof host.showPopover === 'function') host.showPopover();
      for (let i = 0; i < particles; i += 1) {
        const s = document.createElement('span');
        const left = (Math.random() * 100);
        const dx = ((Math.random() - 0.5) * 60) + 'vw';
        const dy = (-(Math.random() * 40 + 70)) + 'vh';
        const rot = ((Math.random() - 0.5) * 1440) + 'deg';
        const delay = Math.random() * 240;
        const len = duration + Math.random() * 400;
        s.style.left = left + '%';
        s.style.background = colors[i % colors.length];
        s.style.setProperty('--dx', dx);
        s.style.setProperty('--dy', dy);
        s.style.setProperty('--rot', rot);
        s.style.animationDelay = delay + 'ms';
        s.style.animationDuration = len + 'ms';
        host.appendChild(s);
      }
      setTimeout(() => {
        host.innerHTML = '';
        if (typeof host.hidePopover === 'function') try { host.hidePopover(); } catch (e) {}
      }, duration + 800);
    };

    document.addEventListener('cart:updated', function () {
      if (alreadyFired()) return;
      markFired();
      burst();
    });
  })();
